import { FC } from "react";
import { observer } from "mobx-react";
import { Box } from "@mui/material";

import Column from "../ui/core/Column";
import { useChatStore } from "../../hooks/useChatStore";
import CategoryCards from "../ui/home/CategoryCards";
import ChatSection from "./components/ChatSection";
import ChatInput from "./components/ChatInput";
import ClaimSummaryBar from "../claims/ClaimSummaryBar";
import ContractSummaryBar from "../preChats/contract-research/ContractSummaryBar";
import PolicySummaryBar from "../preChats/policy-questions/PolicySummaryBar";
import { useClaimsStore } from "../../hooks/useClaimsStore";

const CONTAINER_STYLES = {
  flex: 1,
  height: "100%",
  width: "100%",
  minWidth: 0,
  minHeight: 0,
  overflow: "hidden",
  justifyContent: "center",
  alignItems: "center",
};

const EMPTY_CHAT_COLUMN_STYLES = {
  flex: 1,
  height: "100%",
  width: "100%",
  minWidth: 0,
  minHeight: 0,
  overflow: "hidden",
  justifyContent: "flex-start",
  alignItems: "stretch",
};

const ChatContent: FC = observer(() => {
  const chatStore = useChatStore();
  const claimsStore = useClaimsStore();

  const { activeChatId } = chatStore;
  const predefaultQuestions =
    chatStore.claimIdToPreview || chatStore?.chatDetails?.claim_number
      ? claimsStore.predefaultQuestions
      : undefined;

  if (!activeChatId) {
    return (
      <Column sx={EMPTY_CHAT_COLUMN_STYLES}>
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            overflowY: "auto",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <CategoryCards />
        </Box>

        <ChatInput
          preDefaultQuestions={predefaultQuestions}
          forceEnable={!!claimsStore.claimActivePredefaultQuestion}
        />
      </Column>
    );
  }

  return (
    <Column sx={{ ...CONTAINER_STYLES, position: "relative" }}>
      {chatStore.chatDetails?.claim_number ? (
        <ClaimSummaryBar />
      ) : chatStore.contractPreviewForChat ? (
        <ContractSummaryBar />
      ) : chatStore.policyPreviewForChat ? (
        <PolicySummaryBar hideBack />
      ) : null}

      <ChatSection />

      <ChatInput
        preDefaultQuestions={predefaultQuestions}
        forceEnable={!!claimsStore.claimActivePredefaultQuestion}
      />
    </Column>
  );
});

export default ChatContent;
